module.exports = __webpack_public_path__ + "static/media/ethereum-logo.5144f062.svg";